import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import qs from 'qs'
import axiosUtil from '../util/axiosUtil.js'
import {
  Message,
  MessageBox
} from 'element-ui';
import index from '@/page/index'
import algorithmDetail from '@/components/algorithmDetail'
import knowledgeMarket from '@/page/knowledgeMarket' //知识市场
import memberCenterIndex from '@/page/memberCenter/memberCenterIndex' //会员中心及其页面
import knowledgeFootprint from '@/page/memberCenter/knowledgeFootprint'
import messageReminder from '@/page/memberCenter/messageReminder'
import KnowledgeOrder from '@/page/memberCenter/KnowledgeOrder'
import personalInformation from '@/page/memberCenter/personalInformation'
import accountInformation from '@/page/memberCenter/accountInformation'
import userRegistration from '@/page/memberCenter/userRegistration' //用户注册
import userLogin from '@/page/memberCenter/userLogin' //用户登录
import forgetPass from '@/page/memberCenter/forgetPass' //忘记密码
import wechatLogin from '@/page/memberCenter/wechatLogin' //微信登录完善信息
import changePass from '@/page/memberCenter/changePass' //修改密码
import changePhoneNumber from '@/page/memberCenter/changePhoneNumber' //修改手机号码1
import changeMobile from '@/page/memberCenter/changeMobile' //修改手机号码
import changeEmail from '@/page/memberCenter/changeEmail' //修改邮箱
import toolKnowledgeDetails from '@/components/toolKnowledgeDetails'
import pageFooter from '@/components/pageFooter'
import registerSuccess from '@/components/registerSuccess'
import error403 from '@/components/error403'
import error404 from '@/components/error404'
import error500 from '@/components/error500'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base:'/computing/',
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/algorithmDetail',
    component: algorithmDetail
  }, {
    path: '/knowledgeMarket',
    component: knowledgeMarket
  }, {
    path: '/memberCenterIndex',
    component: memberCenterIndex,
    //需要登录
    meta: {
      auth: true
    },
    children: [{
      path: '/memberCenterIndex/KnowledgeOrder',
      name: 'KnowledgeOrder',
      component: KnowledgeOrder,
      meta: {//需要登录
        auth: true
      }
    }, { //修改用户基本信息
      path: '/memberCenterIndex/personalInformation',
      name: 'personalInformation',
      component: personalInformation,
      meta: {//需要登录
        auth: true
      }
    }, { //修改绑定密码
      path: '/memberCenterIndex/changePass',
      name: 'changePass',
      component: changePass,
      meta: {//需要登录
        auth: true
      }
    }, {
      path: '/memberCenterIndex/changePhoneNumber',
      name: 'changePhoneNumber',
      component: changePhoneNumber,
      meta: {//需要登录
        auth: true
      }
    }, { //修改绑定手机号
      path: '/memberCenterIndex/changeMobile',
      name: 'changeMobile',
      component: changeMobile,
      meta: {//需要登录
        auth: true
      }
    }, { //修改绑定邮箱
      path: '/memberCenterIndex/changeEmail',
      name: 'changeEmail',
      component: changeEmail,
      meta: {//需要登录
        auth: true
      }
    }, {
      path: '/memberCenterIndex/knowledgeFootprint',
      name: 'knowledgeFootprint',
      component: knowledgeFootprint,
      meta: {//需要登录
        auth: true
      }
    }, {
      path: '/memberCenterIndex/messageReminder',
      name: 'messageReminder',
      component: messageReminder,
      meta: {//需要登录
        auth: true
      }
    }],
    redirect: "/memberCenterIndex/knowledgeFootprint"
  }, {
    path: '/KnowledgeOrder',
    component: KnowledgeOrder,
    //需要登录
    meta: {
      auth: true
    },
  }, {
    path: '/accountInformation',
    component: accountInformation,
    //需要登录
    meta: {
      auth: true
    }
  }, {
    path: '/memberCenter',
    redirect: '/knowledgeFootprint',
    meta: {//需要登录
      auth: true
    }
  }, {
    path: '/userRegistration',
    component: userRegistration
  }, {
    name:'userLogin',
    path: '/userLogin',
    component: userLogin
  }, {
    path: '/forgetPass',
    component: forgetPass
  }, {
    path: '/wechatLogin',
    component: wechatLogin
  }, {
    path: '/toolKnowledgeDetails',
    component: toolKnowledgeDetails
  }, {
    path: '/registerSuccess',
    component: registerSuccess,
    //需要登录
    meta: {
      auth: true
    },
  }, {
    path: '/error403',
    component: error403
  }, {
    path: '/error404',
    component: error404
  }, {
    path: '/error500',
    component: error500
  }],
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach(function(to, from, next) {
  if (to.path === '/userLogin' || to.path === '/userRegistration' || to.path === '/forgetPass' || to.path ===
    '/wechatLogin') {
    next();
  } else {
    //需要登录的页面
    let islogined =  store.state.islogined;
    if (!(islogined === 'true' || islogined === true)) {
      //自动登录
      let autoLogin = store.state.autoLogin;
      if (autoLogin === 'true' || autoLogin === true) {
        //保存的token
        let ltoken = store.state.token;
        // let ltoken = localStorage.getItem('token');
        var data_ = {
          "token": ltoken
        };

        let paramdata = {};
        paramdata.url = "/jwt/token/checkToken";
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            var userInfoStr = res.data.result;
            var userInfo = eval('(' + userInfoStr + ')');
            userInfo.token = ltoken;
            //默认自动登录
            userInfo.autoLogin = true;
            // 将用户token保存到vuex中
            store.commit('LOGIN', userInfo);
            next();
          } else {
            //自动登录失败 清空账号信息
            store.commit('LOGOUT');
            next('/userLogin');
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        axiosUtil.postServer(paramdata);
      }else{
        //登录状态(且state中的token无值,并且不记住密码的登录)
        if (to.meta && to.meta.auth) {
          store.commit('CHEACK_LOGIN');
          if (store.state.islogined) {
            next();
          } else {
            next('/userLogin');
          }
        } else {
          next();
        }
      }
    } else { //已登录
      if (to.meta && to.meta.auth) {
        store.commit('CHEACK_LOGIN');
        if (store.state.islogined) {
          next();
        } else {
          next('/userLogin');
        }
      } else {
        next();
      }
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js